<ng-container *ngIf="showNick">
  <div *ngIf="loading;" style="height: 500px">
    <app-new-spinner></app-new-spinner>
  </div>
  <app-nick *ngIf="showNick"
            (loadedEvent)="onLoadedAction()"
            (savedNickAction)="onSavedNick()"></app-nick>

</ng-container>

<div *ngIf="showOnboardingSliders" style="position: relative"
     [ngStyle.gt-sm]="{'padding': '60px 40px 20px 40px'}"
     [ngStyle.lt-md]="{'padding': '0 20px'}"
>
  <app-icon *ngIf="!isMobile && !loading"
            name="close"
            color="#B3B3B3"
            [mat-dialog-close]="true"
            (click)="onSkip()"
            style="position: absolute; right: 5px; top: 5px; cursor: pointer;"></app-icon>
 <app-slider
              [config]="sliderConfig"
              [stopOnLastSlide]="true"
              (loadedEvent)="onLoadedAction()"
              (lastSlideAction)="onLastSlideAction()"></app-slider>
  <div *ngIf="loading; else buttons" style="height: 500px">
    <app-new-spinner></app-new-spinner>
  </div>
  <ng-template #buttons>
    <div fxLayout="column">
      <app-new-loader-button *ngIf="!finished"
                             (buttonClick)="onGoNext()"
                             class="big-button button-250 self-center"
                             [customType]="LoaderButtonType.RAISED"
                             color="accent">Dalej
      </app-new-loader-button>

      <app-new-loader-button *ngIf="finished"
                             [mat-dialog-close]="true"
                             (buttonClick)="onClose()"
                             class="big-button button-250 self-center"
                             [customType]="LoaderButtonType.RAISED"
                             color="accent">Rozpocznij
      </app-new-loader-button>

      <button *ngIf="handsetService.isMobile"
              type="button" mat-button class="self-center font-bold font-medium primary-color "
              (click)="onSkip()"
              [mat-dialog-close]="true"
              style="width: 250px;">
        Pomiń
      </button>


    </div>
  </ng-template>
</div>
